module.exports = __webpack_public_path__ + "img/logo_banner_color.973c172.svg";